/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Next_SessionInputs */

const en_hero_next_session = /** @type {(inputs: Hero_Next_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A session`)
};

const pl_hero_next_session = /** @type {(inputs: Hero_Next_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia`)
};

/**
* | output |
* | --- |
* | "A session" |
*
* @param {Hero_Next_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_next_session = /** @type {((inputs?: Hero_Next_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Next_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_next_session(inputs)
	return en_hero_next_session(inputs)
});